import useProfile from 'hooks/useProfile';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setError } from 'store/user';

const ModalWindow = ({ additionalClass, close, children, style }) => {
  const {pathname} = useLocation();
  const windowRef = useRef(null);
  const {errorText} = useProfile();
  const [isAlignedTop, setIsAlignedTop] = useState(false);
  const dispatch = useDispatch();


  const setBodyOverflow = (value) => {
    if (!pathname.includes('tutorial')) {
      document.body.style.overflow = value
    }
  }

  useEffect(() => {
    const checkHeight = () => {
      if (windowRef.current) {
        const windowHeight = windowRef.current.offsetHeight;
        const contentHeight = windowRef.current.scrollHeight;

        setIsAlignedTop(contentHeight > windowHeight);
      }
    };


    checkHeight();

    window.addEventListener('resize', checkHeight);

    return () => {
      window.removeEventListener('resize', checkHeight);
      setBodyOverflow('');
    };
  }, [children]);

  useEffect(() => {
    if (isAlignedTop) {
      setBodyOverflow('hidden')
    } else {
      setBodyOverflow('')
    }

    return () => {
      if (errorText !== null) {
        dispatch(setError(null))
      }
    }
  }, [isAlignedTop])

  return (
    <div
      className={`modal-window ${isAlignedTop ? 'modal-window--align-top' : ''} ${additionalClass ? additionalClass : ''}`}
      ref={windowRef}
      onClick={close}
      style={style}
    >
      {children}
    </div>
  );
};

export default ModalWindow;
